export default "__VITE_ASSET__S42ajr4G__"